import React, { FunctionComponent } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import EmailActivation from "./pages/email-activation/email-activation"
import NotFound from "./pages/not-found/not-round"
import PasswordReset from "./pages/password-reset/password-reset"
import FriendCode from "./pages/friend-code/friend-code"

export const App: FunctionComponent = () => (
    <>
        <BrowserRouter>
            <Routes>
                <Route
                    path="/email-activation"
                    element={<EmailActivation />}
                />
                <Route path="/password-reset" element={<PasswordReset />} />
                <Route path="/friend/:code" element={<FriendCode />} />
                <Route path="*" element={<NotFound />}></Route>
            </Routes>
        </BrowserRouter>
    </>
)
